/**
 * Artecs Kanagawa — theme entry.
 *
 * Drives the header SP drawer toggle. Keep this file minimal; section-level
 * behaviour belongs in dedicated entry files imported here when added.
 */

import '../css/header.css';
import '../css/footer.css';

(() => {
  const root = document.querySelector('.artecs-header');
  if (!root) {
    return;
  }

  const toggle = root.querySelector('[data-artecs-drawer-toggle]');
  const drawer = root.querySelector('[data-artecs-drawer]');
  if (!toggle || !drawer) {
    return;
  }

  const close = () => {
    root.classList.remove('is-drawer-open');
    toggle.setAttribute('aria-expanded', 'false');
    drawer.setAttribute('aria-hidden', 'true');
  };

  const open = () => {
    root.classList.add('is-drawer-open');
    toggle.setAttribute('aria-expanded', 'true');
    drawer.setAttribute('aria-hidden', 'false');
  };

  toggle.addEventListener('click', () => {
    if (root.classList.contains('is-drawer-open')) {
      close();
    } else {
      open();
    }
  });

  drawer.querySelectorAll('a').forEach((link) => {
    link.addEventListener('click', close);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      close();
    }
  });
})();

/**
 * スクロール位置の保存と復元（旧 site.min.js から移植）。
 * リロード・戻る/進む時に直前の Y を復元（BFCache 非効時のフォールバック）。
 */
(() => {
  const KEY = 'artecs_scroll_' + location.pathname;
  window.addEventListener('pagehide', () => {
    try {
      sessionStorage.setItem(KEY, String(window.scrollY));
    } catch (e) {
      /* sessionStorage 不可は無視 */
    }
  });

  const restore = () => {
    if (location.hash) return;
    const nav = performance.getEntriesByType('navigation')[0];
    const navType = nav ? nav.type : '';
    if (navType !== 'reload' && navType !== 'back_forward') return;
    let y;
    try {
      y = sessionStorage.getItem(KEY);
    } catch (e) {
      return;
    }
    if (y === null) return;
    const target = parseInt(y, 10);
    window.scrollTo({ top: target, behavior: 'instant' });
    window.addEventListener('load', () => {
      window.scrollTo({ top: target, behavior: 'instant' });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', restore);
  } else {
    restore();
  }
})();
